import "reflect-metadata";

import { createApp } from "vue";
import App from "@/App.vue";
import router from "@/router";
import NexusApp from "@cems-eco/core";
import config from "@/config";
import components from "@/components";
import modules from "./module";
import { updateConfig } from "./config/config-json";
import { registerDirective } from "./directives";

const app = createApp(App).use(router);

app.use(registerDirective);
app.config.errorHandler = (err, vm, info) => {
  // Custom error handling logic
  console.error("Vue error:", err, info);
};

router.isReady().then(async () => {
  const appConfig = await updateConfig(config);
  const nexus = NexusApp.app(appConfig).module(modules);
  await nexus.register(app, { components });
  
  app.mount("#app");
});
